var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.998,
    height: 21.001,
    viewBox: "0 0 20.998 21.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vault",
    transform: "translate(-287.447 -410.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vault-2",
    "data-name": "Vault",
    d: "M5233.947,11309.48V11291.9a1.214,1.214,0,0,1,1.2-1.221h17.577a1.211,1.211,0,0,1,1.218,1.2v17.576a1.21,1.21,0,0,1-1.2,1.221h-17.584A1.212,1.212,0,0,1,5233.947,11309.48Zm1.218-6.12v2.683a.255.255,0,0,0,.244.244h.488v1.288a1.4,1.4,0,0,0,1.4,1.395h13.969a1.464,1.464,0,0,0,1.464-1.462v-13.66a1.476,1.476,0,0,0-1.464-1.465h-13.969a1.4,1.4,0,0,0-1.4,1.4v1.288h-.488a.252.252,0,0,0-.244.241V11298a.258.258,0,0,0,.244.244h.488v4.877h-.488A.256.256,0,0,0,5235.165,11303.36Zm1.221,4.227v-1.544a.25.25,0,0,0-.244-.244h-.488v-2.2h.488a.252.252,0,0,0,.244-.244V11298a.25.25,0,0,0-.244-.244h-.488v-2.2h.488a.251.251,0,0,0,.244-.244v-1.532a.9.9,0,0,1,.894-.908h.014v0h13.969a.975.975,0,0,1,.976.972v13.662a.965.965,0,0,1-.954.977h-14A.9.9,0,0,1,5236.386,11307.587Zm14.389-9.351v4.88a.244.244,0,0,0,.488,0v-4.88a.244.244,0,1,0-.488,0Zm-3.534,4.15-.122.5h.488l-.122-.5a1.707,1.707,0,0,0,1-.412l.258.435.344-.344-.443-.267a1.669,1.669,0,0,0,.415-.99l.5.122v-.488l-.5.122a1.734,1.734,0,0,0-.4-1l.431-.261-.34-.349-.267.442a1.674,1.674,0,0,0-.991-.42l.12-.488h-.494l.125.488a1.682,1.682,0,0,0-.994.42l-.267-.442-.344.349.438.261a1.713,1.713,0,0,0-.412,1l-.5-.122v.488l.5-.122a1.669,1.669,0,0,0,.417.99l-.443.267.344.344.261-.435A1.705,1.705,0,0,0,5247.241,11302.387Zm-.636-1.712a.769.769,0,1,1,.769.77A.768.768,0,0,1,5246.6,11300.675Z",
    transform: "translate(-4946 -10880)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.99dd1a5365976cf9b73f89a59bc94e80.svg";
export { ForwardRef as ReactComponent };